import {useEffect, useState} from "react";

export default function useWindowDimensions() {

    const hasWindow = typeof window !== 'undefined';

    function getWindowDimensions() {
        const width = hasWindow ? window.innerWidth : null;
        const height = hasWindow ? window.innerHeight : null;
        return {
            width,
            height,
        };
    }

    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    // eslint-disable-next-line consistent-return
    useEffect(() => {
        if (hasWindow) {
            function handleResize() {
                setWindowDimensions(getWindowDimensions());
            }

            window.addEventListener('resize', handleResize);
            return () => window.removeEventListener('resize', handleResize);
        }
    }, [hasWindow]);

    return windowDimensions;
}

export const useDimensions = (screenWidth, imageWidth, imageHeight) => {
    if (imageWidth < screenWidth) return [imageWidth, imageHeight];
    return [screenWidth, Math.round(screenWidth/imageWidth * imageHeight)];
};

export const useVideoDimensions = (media, screenWidth) => {
    if (!media || media.full_resolution.length === 0) {
        return [Math.ceil((screenWidth / 16) * 9), screenWidth];
    }
    const height = media.full_resolution[0];
    const width = media.full_resolution[1];
    if (width > screenWidth) return [Math.round(screenWidth/width * height), screenWidth];
    return media.full_resolution;
};
